// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2MKqh","left":"StickyBox_left__3DJWs","right":"StickyBox_right__x2V6F"};